import { render, staticRenderFns } from "./ProductPageHeader.vue?vue&type=template&id=f3e74db2&scoped=true"
import script from "./ProductPageHeader.vue?vue&type=script&lang=js"
export * from "./ProductPageHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductPageHeader.vue?vue&type=style&index=0&id=f3e74db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e74db2",
  null
  
)

export default component.exports